import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { motion } from 'framer-motion';
export function FinalPromise() {
  return <>
      <Section className="bg-white text-center" data-id="element-42">
        <h2 className="text-4xl font-serif text-[#0f4c3a] mb-8" data-id="element-43">
          La promesa grande (realista)
        </h2>

        <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto" data-id="element-44">
          No te voy a prometer "hazte rica en 7 días". Pero sí te digo una
          verdad poderosa:
        </p>

        <div className="bg-[#fcfbf7] p-8 rounded-2xl border border-[#d4af37]/20 max-w-3xl mx-auto mb-6" data-id="element-45">
          <p className="text-xl text-[#0f4c3a] font-medium mb-6" data-id="element-46">
            Cuando una mujer deja la culpa, cambia su identidad, regula su
            emoción y sostiene un sistema simple… Pasan cosas muy concretas:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-47">
            {['mejora su control', 'baja impulsos', 'prioriza mejor', 'detecta fugas invisibles', 'toma decisiones más rentables', 'y se abre a oportunidades'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-48">
                <div className="w-1.5 h-1.5 bg-[#d4af37] rounded-full" data-id="element-49" />
                <span className="text-slate-700" data-id="element-50">{item}</span>
              </div>)}
          </div>

          <p className="mt-8 text-lg font-serif text-[#d4af37] font-bold" data-id="element-51">
            Ese es el juego real. Y eso es lo que ABUNDANCIA & DINERO está
            diseñado para provocar.
          </p>
        </div>
      </Section>

      <Section dark className="text-center pb-16" data-id="element-52">
        <div className="max-w-2xl mx-auto" data-id="element-53">
          <h2 className="text-3xl font-serif text-[#d4af37] mb-6" data-id="element-54">
            Último golpe (con cariño, pero directo)
          </h2>

          <p className="text-lg text-white mb-6" data-id="element-55">
            Si sigues viviendo como si el futuro no fuera a llegar… el futuro
            llega igual. Con emergencias, con responsabilidades, con gente que
            depende de ti.
          </p>

          <p className="text-xl text-white mb-8" data-id="element-56">
            La pregunta no es "¿puedo?" La pregunta es:
          </p>

          <p className="text-2xl md:text-3xl font-serif text-[#d4af37] mb-12 italic" data-id="element-57">
            ¿Cuánto más vas a sobrevivir antes de construir?
          </p>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-[#d4af37]/30" data-id="element-58">
            <p className="text-white mb-6" data-id="element-59">
              Si este texto te describió… no es casualidad. Haz clic y accede a
              ABUNDANCIA & DINERO ahora:
            </p>

            <CTAButton text="QUIERO ABUNDANCIA & DINERO" fullWidth className="text-xl py-6" data-id="element-60" />

            <div className="mt-6 flex flex-col gap-2 text-sm text-white" data-id="element-61">
              <span data-id="element-62">Acceso inmediato.</span>
              <span data-id="element-63">
                Y empiezas hoy mismo a cambiar el chip… y a construir el sistema
                que por fin te sostenga.
              </span>
            </div>
          </div>
        </div>
      </Section>

      <footer className="bg-[#0a3327] py-8 text-center text-white/40 text-sm" data-id="element-64">
        <div className="container mx-auto px-4" data-id="element-65">
          <p data-id="element-66">
            &copy; {new Date().getFullYear()} Abundancia & Dinero. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </>;
}